const ConsecutiveDays = class ConsecutiveDays {
    constructor() {
        this.isActive = false;
        this.params = {
            '3_daily_watch': false,
            '5_daily_watch': false,
            '10_daily_watch': false
        };
    }
};

export default ConsecutiveDays;
